<template>
  <div
    id="kt_content_container"
    class="d-flex flex-column-fluid align-items-start container-xxl"
  >
    <!--begin::Post-->
    <div class="content flex-row-fluid" v-if="isLoaded">
      <!--begin::Tables Widget 12-->
      <div class="card mb-5 mb-xl-8">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bolder fs-3 mb-1">Testlerim</span>
            <span class="text-muted mt-1 fw-bold fs-7"
              >{{ count }} adet test tamamladınız.</span
            >
          </h3>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div class="card-body py-3">
          <!--begin::Table container-->
          <div class="table-responsive">
            <!--begin::Table-->
            <table class="table align-middle gs-0 gy-4">
              <!--begin::Table head-->
              <thead>
                <tr class="fw-bolder text-muted bg-light">
                  <th class="ps-4 min-w-300px rounded-start">Test adı</th>
                  <th class="min-w-200px">Doldurma tarihi</th>
                  <th class="min-w-200px text-end rounded-end"></th>
                </tr>
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody>
                <tr v-for="(test, index) in mytests" :key="`test-${index}`">
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="d-flex justify-content-start flex-column">
                        <a
                          href="#"
                          class="
                            text-dark
                            fw-bolder
                            text-hover-primary
                            mb-1
                            fs-6
                          "
                          >{{ test.name }}</a
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="text-muted fw-bold text-muted d-block fs-7">{{
                      test.date
                    }}</span>
                  </td>
                  <td class="text-end">
                    <span
                      @click="deleteTest(test.id)"
                      class="
                        btn
                        btn-bg-light
                        btn-color-muted
                        btn-active-color-primary
                        btn-sm
                        px-4
                      "
                      >Testi sil</span
                    >
                  </td>
                </tr>
              </tbody>
              <!--end::Table body-->
            </table>
            <!--end::Table-->
          </div>
          <!--end::Table container-->
        </div>
        <!--begin::Body-->
      </div>
      <!--end::Tables Widget 12-->
    </div>
    <!--end::Post-->
  </div>
</template>

<script>
import * as API from "@/services/";
import { makeDate } from "@/helpers";
export default {
  data() {
    return {
      token: this.$store.getters.getAccessToken,
      isLoaded: false,
      count: 0,
      mytests: [],
    };
  },
  async created() {
    await this.getMyTests();
  },
  methods: {
    getMyTests: async function () {
      let vm = this;

      let response = await API.getMyTests(vm.token);

      vm.count = response.data.length;

      vm.mytests = response.data.map((item) => {
        let obj = {};

        obj.id = item.id;
        obj.name = item.survey.name;
        obj.date = makeDate(item.created_at);

        return obj;
      });

      vm.isLoaded = true;
    },
    deleteTest: async function (id) {
      console.log("id >>", id);
      let vm = this;

      let form = {
        id,
        token: vm.token,
      };

      await API.deleteTest(form);

      return vm.getMyTests();
    },
  },
};
</script>